import axios from "axios";
import { sendOTP } from "./controller";

const client_base_url = process.env.REACT_APP_CLIENT_BASE_URL;
const base_url = process.env.REACT_APP_BASE_URL;
const saas_api_urll = process.env.REACT_APP_SAAS_API_URL;

export const url = {
  apiUrl: base_url + "api/web/",
  apiUrlWebapp: base_url + "api/webapp/",
  saasApiUrl: saas_api_urll + "api/",
  publicUrl: base_url + "api/public/",
  imageUrl: "", // API thi set thase
  gamesUrl: saas_api_urll + "api/game/",
  gamesTypesUrl: saas_api_urll + "api/gameType/",
  apiUrlV2: base_url + "api/v2/",
  scrim_url: saas_api_urll + "api/v2/scrim/",
  saasApiUrlV2: saas_api_urll + "api/v2/",
  client_base_url,
  saasApiD11Url: saas_api_urll + "api/web/",
  authUrl: base_url + "api/auth/",
  sendOTP: base_url + "api/",
};

export const initializeImageUrl = async () => {
  try {
    const { data } = await axios.get(
      "https://api.gamerji.tech/api/bucket/url"
    );

    if (data?.success && data?.url) {
      url.imageUrl = data.url + '/';
      console.log("Image URL:", url.imageUrl);
    }
  } catch (err) {
    console.error("Image URL Error:", err);
  }
};

// Auto call
initializeImageUrl();